import { api } from './api'

function assertSuccess(body: { success?: boolean; message?: string; data?: unknown }) {
  if (!body?.success) {
    throw new Error(body?.message || 'Request failed')
  }
  return body.data
}

export type StripeAutoWithdraw = 'off' | 'daily' | 'weekly' | 'monthly'

export type StripeConnectStatus = {
  storeId: number
  connectAccountId: string | null
  chargesEnabled: boolean
  payoutsEnabled: boolean
  detailsSubmitted: boolean
  autoWithdraw: StripeAutoWithdraw
  autoWithdrawAnchorAt: string | null
  readyForCheckout: boolean
  currencyEligible: boolean
  stripeConfigured: boolean
}

export async function fetchStripeConnect(storeId: number): Promise<StripeConnectStatus> {
  const { data } = await api.get(`/storebusiness/stores/${storeId}/stripe/connect`)
  return assertSuccess(data) as StripeConnectStatus
}

export async function startStripeConnectOnboarding(
  storeId: number,
): Promise<{ url: string; connectAccountId: string }> {
  const { data } = await api.post(`/storebusiness/stores/${storeId}/stripe/connect/account-link`)
  return assertSuccess(data) as { url: string; connectAccountId: string }
}

export async function syncStripeConnect(storeId: number): Promise<StripeConnectStatus> {
  const { data } = await api.post(`/storebusiness/stores/${storeId}/stripe/connect/sync`)
  return assertSuccess(data) as StripeConnectStatus
}

export async function updateStripeAutoWithdraw(
  storeId: number,
  schedule: StripeAutoWithdraw,
): Promise<StripeConnectStatus> {
  const { data } = await api.patch(`/storebusiness/stores/${storeId}/stripe/auto-withdraw`, {
    schedule,
  })
  return assertSuccess(data) as StripeConnectStatus
}
